import useAppStore from "@/store/use-app-store";
import { isObjectEmpty } from "data/functions";
import { WebStorageStateStore } from "oidc-client-ts";
import React from "react";
// contexts/OidcContext.js
import { AuthProvider } from "react-oidc-context";

export const OidcContext = React.createContext();

const oidcConfig = {
  authority: process.env.REACT_APP_KEYCLOAK_AUTHORITY,
  client_id: process.env.REACT_APP_KEYCLOAK_CLIENT_ID,
  client_secret: process.env.REACT_APP_KEYCLOAK_CLIENT_SECRET,

  // automaticSilentRenew: true,
  checkSessionMethod: "web_message",
  monitorSession: true,

  post_logout_redirect_uri: window.location.origin,
  // post_logout_redirect_uri:
  //   process.env.REACT_APP_KEYCLOAK_REDIRECT_URI || window.location.origin,
  // redirect_uri:
  //   process.env.REACT_APP_KEYCLOAK_REDIRECT_URI || window.location.origin,
  redirect_uri: window.location.origin,
  scope: "openid profile email offline_access",
  // silentCheckSsoRedirectUri: window.location.origin + "/silent-check-sso.html",
  // silent_redirect_uri: window.location.origin + "/silent-check-sso.html",

  userStore: new WebStorageStateStore({ store: window.localStorage }),
  onSigninCallback: () => {
    window.history.replaceState({}, document.title, window.location.pathname);
    if (!isObjectEmpty(useAppStore.getState()?.cacheMessage)) {
      useAppStore.setState({
        cacheMessage: {},
        message: useAppStore.getState()?.cacheMessage,
      });
    }
  },
};

function OidcProvider({ children }) {
  return <AuthProvider {...oidcConfig}>{children}</AuthProvider>;
}

export { OidcProvider };
